import { Form, Button, Typography, Slider, Select, Card, Checkbox, Input, Divider, notification, message } from 'antd';
import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { SendToBackend, ErrorConnectionFailed } from './HelperContactBackend';
import './Stepper.css';
import {calculate_payment_amount} from './utils';
var md5 = require('md5');

const { Option } = Select;
const { Text } = Typography;

export const FormSurvey = ({ next, useMobileVersion, platform, sessionId, emailIdentifier, donationOptions, demographicSurveyQuestions, usageSurveyQuestions, techsavvinessSurveyQuestions, setAmountToBePayed }) => {

    const [surveyStage, setSurveyStage] = useState("demographics");
    const [demographicsAnswers, setDemographicsAnswers] = useState(null);
    const [demographicsForm] = Form.useForm();
    const [usageForm] = Form.useForm();

    const defaultAgreementSlider = {
        0: {
            label: 'Strongly\nDisagree',
            style: { fontSize: useMobileVersion ? "x-small" : "medium" }
        },
        25: {
            label: 'Slightly\nDisagree',
            style: { fontSize: useMobileVersion ? "x-small" : "medium" }
        },
        50: {
            label: 'Neutral',
            style: { fontSize: useMobileVersion ? "x-small" : "medium" }
        },
        75: {
            label: 'Slightly\nAgree',
            style: { fontSize: useMobileVersion ? "x-small" : "medium" }
        },
        100: {
            label: 'Strongly\nAgree',
            style: { fontSize: useMobileVersion ? "x-small" : "medium" }
        }
    };

    // Expects an array of 5 strings.
    function GetAgreementSlider(options) {
        if (options.length !== 5) {
            return defaultAgreementSlider;
        }
        return {
            0: {
                label: options[0].replace(" ", "\n"),
                style: { fontSize: window.innerWidth <= 850 ? "xx-small" : (window.innerWidth <= 980 ? "small" : "medium") }
            },
            25: {
                label: options[1].replace(" ", "\n"),
                style: { fontSize: window.innerWidth <= 850 ? "xx-small" : (window.innerWidth <= 980 ? "small" : "medium") }
            },
            50: {
                label: options[2].replace(" ", "\n"),
                style: { fontSize: window.innerWidth <= 850 ? "xx-small" : (window.innerWidth <= 980 ? "small" : "medium") }
            },
            75: {
                label: options[3].replace(" ", "\n"),
                style: { fontSize: window.innerWidth <= 850 ? "xx-small" : (window.innerWidth <= 980 ? "small" : "medium") }
            },
            100: {
                label: options[4].replace(" ", "\n"),
                style: { fontSize: window.innerWidth <= 850 ? "xx-small" : (window.innerWidth <= 980 ? "small" : "medium") }
            }
        }
    }

    // Expects an integer between 0 and 100
    function PercentileToIndex(p) {
        switch (p) {
            case 0:
                return 0;
            case 25:
                return 1;
            case 50:
                return 2;
            case 75:
                return 3;
            case 100:
                return 4;
        }
    }

    // Expects an array of questions, form values, and an array of answers.
    function AddAnswersToList(questions, answers, answerList) {
        questions.forEach((questionObject, index) => {
            const question_id = questionObject.question_id;
            var answerObject = {
                "session_id": sessionId.session_id,
                "question_id": question_id,
                "answer": null
            }
            if ((typeof answers[question_id + "PreferNotToSay"] !== 'undefined') && (answers[question_id + "PreferNotToSay"])) {
                answerObject.answer = "";
            }
            else if ((typeof answers[question_id] !== 'undefined') && (answers[question_id] === "Other: Specify")) {
                answerObject.answer = answers[question_id + "CustomValue"];
            }
            else {
                switch (questionObject.question_type) {
                    case "multichoice":
                        answerObject.answer = answers[question_id];
                        break;
                    case "point-scale":
                        const answerIndex = PercentileToIndex(answers[question_id]);
                        answerObject.answer = questionObject.options[answerIndex];
                        break;
                    case "select_all_apply":
                        answerObject.answer = answers[question_id].toString();
                        break;
                }
            }
            answerList.push(answerObject);
        });
    };

    // Expects form values
    function SubmitSurveyAnswers(usageAnswers) {
        // Convert the survey answers to the correct format.

        if (platform === 'tiktok') {
            var payment_amount = calculate_payment_amount(donationOptions.LikeHistory,
                donationOptions.SearchHistory,
                donationOptions.ShareHistory,
                donationOptions.SessionHistory,
                donationOptions.TikTokFavourites,
                donationOptions.TikTokFollowing,
                donationOptions.TikTokFollowers,
                donationOptions.Comments,
                donationOptions.CommentText,
                donationOptions.AdData,
                donationOptions.TikTokAppSettings,
                true);
        } else {
            var payment_amount = calculate_payment_amount(donationOptions.LikeHistory,
                donationOptions.SearchHistory,
                false,
                false,
                false,
                donationOptions.YouTubeSubscriptions,
                false,
                donationOptions.Comments,
                donationOptions.CommentText,
                false,
                false,
                true);
        }
        //console.log("Payment amount to be added = " + payment_amount);
        var payment_submission = JSON.stringify({
            "email": emailIdentifier,
            "email_md5": md5(emailIdentifier),
            "platform": platform,
            "bonus_payment": payment_amount,
            "donation_options": donationOptions,
            "survey_completed": true
        });
        setAmountToBePayed(payment_amount);
        SendToBackend(payment_submission,
            'payments/',
            () => {
            },
            () => {
                ErrorConnectionFailed();
            })            

        var answerList = [];
        //console.log("Demographics answers:", demographicsAnswers);
        AddAnswersToList(demographicSurveyQuestions, demographicsAnswers, answerList);
        AddAnswersToList(techsavvinessSurveyQuestions, demographicsAnswers, answerList);
        AddAnswersToList(usageSurveyQuestions, usageAnswers, answerList);
        //console.log("Processed answers:", answerList);
        const data = JSON.stringify({"answers": answerList});
        SendToBackend(data, "answers/", next, ErrorConnectionFailed);
    };

    // Expects an integer
    const openNotificationQuestionsUnanswered = (nQuestionsUnanswered) => {
        notification["error"]({
            message: <Text strong>{'Please complete all questions'}</Text>,
            description:
                <Text className="Text">
                    {'You have left '
                        + nQuestionsUnanswered +
                        ' question(s) unanswered. Please fill all questions.\n\n\
You may select "Prefer not to say" if you do not want give a particular piece of information.\n\n'}
                </Text>,
            duration: 10
        });
    };

    // Expects an integer
    const openNotificationTextFieldsEmpty = (nTextFieldsEmpty) => {
        notification["error"]({
            message: <Text strong>{'Please fill in "Specify: Other" fields'}</Text>,
            description:
                <Text className="Text">
                    {'On questions for which you have selected "Other: Specify", \
please type your specified answer in the box provided below the question.\
We detect that you have left empty "Other: Specify" text boxes on '
                        + nTextFieldsEmpty +
                        ' question(s).'}
                </Text>,
            duration: 10
        });
    };

    // Expects form values, an array of questions, and a function which accepts no arguments.
    function VerifyQuestionsCompleted(values, surveyQuestions, onSuccess) {

        // log values
        // console.log(values);
        //

        var nQuestionsUnanswered = 0;
        var nTextFieldsEmpty = 0;
        surveyQuestions.forEach((questionObject, index) => {
            const question_id = questionObject.question_id;
            // Check whether the question is unanswered.
            if ((values[question_id] === undefined) && !(values[question_id + "PreferNotToSay"])) {
                nQuestionsUnanswered++;
            }
            // Check whether the specify text field was left empty, if it was used
            else if (!(values[question_id + "PreferNotToSay"]) && (values[question_id] === "Other: Specify") && (values[question_id + "CustomValue"] === undefined)) {
                //console.log("Question id: ", question_id, "Undefined text box: ", values[question_id + "CustomValue"]);
                nTextFieldsEmpty++;
            }
        });
        if (nQuestionsUnanswered > 0) {
            openNotificationQuestionsUnanswered(nQuestionsUnanswered);
        }
        if (nTextFieldsEmpty > 0) {
            openNotificationTextFieldsEmpty(nTextFieldsEmpty);
        }
        if ((nQuestionsUnanswered === 0) && (nTextFieldsEmpty === 0)) {
            window.scrollTo(0, 0);
            onSuccess();
        }
    }

    // Expects form values
    const onFinishDemographics = (values) => {
        VerifyQuestionsCompleted(values, demographicSurveyQuestions, () => {
            setSurveyStage("usage");
            setDemographicsAnswers(values);
        })
        //console.log(values);
    };

    // Expects form values
    const onFinishUsage = (values) => {
        VerifyQuestionsCompleted(values, usageSurveyQuestions, () => {
            SubmitSurveyAnswers(values);
        })
        //console.log("Finish Usage:", values);

    };

    function OptOutCheckbox(question_id, setQuestionDisabled) {
        return (
            <Form.Item name={question_id + "PreferNotToSay"} valuePropName="checked">
                <Checkbox
                    className={useMobileVersion ? "SurveyOptOutCheckboxMobile" : "SurveyOptOutCheckbox"}

                    onChange={(e) => { setQuestionDisabled(e.target.checked) }}>
                    {useMobileVersion ? "Prefer not to say" : "Prefer\nnot to\nsay"}
                </Checkbox>
            </Form.Item>);
    }

    function SliderQuestion(question_id, question, options, question_category) {
        const [sliderDisabled, setSliderDisabled] = useState((question_category === "platform-use") ?
                                                              usageForm.getFieldValue(question_id + "PreferNotToSay") :
                                                              demographicsForm.getFieldValue(question_id + "PreferNotToSay"));
        return (
            <div className="SurveyQuestionPadding">
                <Text>{question}</Text>
                <div>
                    <div className={useMobileVersion ? "SurveyQuestionMobile" : "SurveySlider"}>
                        <Form.Item
                            name={question_id}
                            preserve
                            initialValue={50}>

                            <Slider
                                marks={GetAgreementSlider(options)}
                                included={false}
                                defaultValue={50}
                                step={25}
                                tooltipVisible={false}
                                disabled={sliderDisabled}
                            />
                        </Form.Item>
                    </div>
                    <div>
                        {OptOutCheckbox(question_id, setSliderDisabled)}
                    </div>
                </div>
            </div>
        );
    };

    function SelectOneDropdown(options, setSelectedValue, selectDisabled) {
        return (
            <Select
                disabled={selectDisabled}
                onChange={(value) => {
                    setSelectedValue(value);
                }}>
                {options.map((item) => (
                    <Option key={item} value={item}>{item}</Option>
                ))}
            </Select>
        );
    }

    function SelectAllDropdown(options, selectDisabled) {
        const [optionsWithCustom, setOptionsWithCustom] = useState(options);
        const [enteredValue, setEnteredValue] = useState(null);
        return (
            <Select
                mode="multiple"
                disabled={selectDisabled}
                dropdownRender={menu => (
                    <div>
                        {menu}
                        <Divider style={{ margin: '4px 0' }} />
                        <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
                            <Input style={{ flex: 'auto' }} onChange={(e) => {
                                setEnteredValue(e.target.value);
                            }} />
                            <a
                                style={{ flex: 'none', padding: '8px', display: 'block', cursor: 'pointer' }}
                                onClick={() => {
                                    if (enteredValue === null) {
                                        message.error('Please enter a custom value.');
                                    }
                                    else if (enteredValue.includes(',')) {
                                        message.error('Custom items cannot contain commas.');
                                    }
                                    else {
                                        setOptionsWithCustom([...optionsWithCustom, enteredValue]);
                                        message.success('New option created. Please select it to add it to your list of responses.')
                                    }
                                }}
                            >
                                <PlusOutlined /> Add item
                            </a>
                        </div>
                    </div>
                )}
            >
                {optionsWithCustom.map((item) => (
                    <Option key={item}>{item}</Option>
                ))}
            </Select>
        );
    }

    function MultichoiceQuestion(question_id, question, options, multiple, question_category) {
        const [selectedValue, setSelectedValue] = useState((question_category === "platform-use") ?
                                                            usageForm.getFieldValue(question_id) :
                                                            demographicsForm.getFieldValue(question_id));
        const [selectDisabled, setSelectDisabled] = useState((question_category === "platform-use") ?
                                                              usageForm.getFieldValue(question_id + "PreferNotToSay") :
                                                              demographicsForm.getFieldValue(question_id + "PreferNotToSay"));
        return (
            <div clear="both" className="SurveyQuestionPadding">
                <Text>{question}</Text>
                <div>
                    <div className={useMobileVersion ? "SurveyQuestionMobile" : "SurveySelect"}>
                        <Form.Item
                            name={question_id}
                            preserve
                        >

                            {multiple ? SelectAllDropdown(options, selectDisabled) : SelectOneDropdown(options, setSelectedValue, selectDisabled)}

                        </Form.Item>
                    </div>
                    <div>

                        {OptOutCheckbox(question_id, setSelectDisabled)}
                    </div>
                </div>
                <Form.Item
                    name={question_id + "CustomValue"}
                    label="Enter custom value:"
                    hidden={!(selectedValue === "Other: Specify") || selectDisabled}
                    className="SurveyQuestionPadding"
                    disabled={selectDisabled}
                >
                    <Input />
                </Form.Item>
            </div>
        );
    }

    function SurveyQuestion({ question_id, question, question_type, options, survey_platform, question_category }) {
        if (survey_platform === "all" || survey_platform === platform) {
            switch (question_type) {
                case 'point-scale':
                    return (
                        <div>
                            {SliderQuestion(question_id, question, options, question_category)}
                        </div>
                    );
                case 'multichoice':
                    return (
                        <div>
                            {MultichoiceQuestion(question_id, question, options, false, question_category)}
                        </div>
                    );
                case 'select_all_apply':
                    return (
                        <div>
                            {MultichoiceQuestion(question_id, question, options, true, question_category)}
                        </div>
                    );
            }
        }
    };
    /*
    function DemographicsSurvey() {
        return (
            
        );
    };

    function UsageSurvey() {
        return (
            
        );
    };
    */
    return (
        <div align="center">
            <Form name="DemographicsSurvey" onFinish={onFinishDemographics} layout="vertical" form={demographicsForm}>
                <div hidden={!(surveyStage === "demographics")}>
                    <Card
                        align="left">
                        <Card.Meta title="Demorgaphics Survey (Survey Part 1/2)" />
                        <Divider />
                        {demographicSurveyQuestions.map((item) => (
                                <SurveyQuestion {...item} />
                        ))}
                    </Card>
                    <Form.Item className="TopMargin">
                        <Button
                            className="RightMargin"
                            disabled>
                            Previous
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit">
                            To Usage questions
                        </Button>
                    </Form.Item>
                </div>
            </Form >

            <Form name="UsageSurvey" onFinish={onFinishUsage} layout="vertical" form={usageForm}>
                <div hidden={!(surveyStage === "usage")}>
                    <Card
                        align="left">
                        <Card.Meta
                            title={(platform === "tiktok" ? "TikTok" : "YouTube") + " Use Survey (Survey Part 2/2)"}
                            description="Text here about how to fill out this survey." />
                        <Divider />
                        {usageSurveyQuestions.map((item) => (
                            <SurveyQuestion {...item} />
                        ))}
                    </Card>
                    <Form.Item className="TopMargin">
                        <Button
                            className="RightMargin"
                            onClick={() => {setSurveyStage("demographics")}}
                            >
                            To Demographics Questions
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            Finish
                        </Button>
                    </Form.Item>
                </div>
            </Form >
        </div>
    )
};

export default FormSurvey;